(() => {
  if (window.LumaResellerGlobes) { window.LumaResellerGlobes.scan(); return; }
  const instances = new Map();
  const scripts = new Map();
  const loadScript = (url) => {
    if (!scripts.has(url)) scripts.set(url, new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url; script.onload = resolve; script.onerror = reject;
      document.head.appendChild(script);
    }));
    return scripts.get(url);
  };
  let worldPromise;
  let countriesPromise, detectedCountryPromise;
  function detectedCountry() {
    if (!detectedCountryPromise) {
      const root = window.Shopify?.routes?.root || '/';
      detectedCountryPromise = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {signal:AbortSignal.timeout(1800)})
        .then(response => response.ok ? response.json() : null)
        .then(data => data?.detected_values?.country?.handle || '')
        .catch(() => '');
    }
    return detectedCountryPromise;
  }
  function attach(element) {
    if (instances.has(element)) return;
    const canvas = element.querySelector('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, ready = false, destroyed = false, frame = 0, last = 0, longitude = -135, latitude = -10, hold = 1500;
    let planet, land, path, colours;
    const readColours = () => {
      const style = getComputedStyle(element);
      colours = { accent:style.getPropertyValue('--luma-accent').trim(), surface:style.getPropertyValue('--luma-surface').trim() };
      if (ready) draw();
    };
    function draw() {
      context.clearRect(0, 0, 320, 320);
      context.beginPath(); path({type:'Sphere'});
      context.fillStyle = colours.surface; context.fill();
      context.strokeStyle = colours.accent; context.lineWidth = 1.4; context.stroke();
      context.beginPath(); path(land);
      context.fillStyle = colours.accent; context.fill();
      context.strokeStyle = colours.surface; context.lineWidth = .5; context.stroke();
    }
    function tick(time) {
      frame = 0;
      if (!ready || !visible || destroyed || motion.matches || document.hidden) return;
      if (last && time - last < 33) { frame = requestAnimationFrame(tick); return; }
      const elapsed = last ? Math.min(time - last, 100) : 0;
      last = time;
      const rotationElapsed = Math.max(0, elapsed - hold);
      hold = Math.max(0, hold - elapsed);
      longitude = (longitude + rotationElapsed * .0048) % 360;
      planet.projection.rotate([longitude,latitude,0]); draw();
      frame = requestAnimationFrame(tick);
    }
    const sync = () => {
      cancelAnimationFrame(frame); frame = 0; last = 0;
      if (ready) { draw(); if (visible && !motion.matches && !document.hidden) frame = requestAnimationFrame(tick); }
    };
    async function initialize() {
      if (ready || destroyed || element.dataset.globeLoading) return;
      element.dataset.globeLoading = 'true';
      try {
        const countryPromise = detectedCountry();
        if (!countriesPromise) countriesPromise = fetch(element.dataset.countriesUrl)
          .then(response => response.ok ? response.json() : null).catch(() => null);
        await loadScript(element.dataset.d3Url);
        await loadScript(element.dataset.topojsonUrl);
        await loadScript(element.dataset.planetaryUrl);
        if (!worldPromise) worldPromise = fetch(element.dataset.worldUrl).then(r => { if (!r.ok) throw Error('Globe geometry unavailable'); return r.json(); });
        const [world, countryData, detected] = await Promise.all([worldPromise, countriesPromise, countryPromise]);
        if (destroyed) return;
        const detectedCode = String(detected).toUpperCase();
        const country = countryData?.countries?.[detectedCode] ? detectedCode : String(element.dataset.country || '').toUpperCase();
        const coordinates = countryData?.countries?.[country];
        if (coordinates?.length === 2 && coordinates.every(Number.isFinite)) {
          latitude = -coordinates[0]; longitude = -coordinates[1];
          element.dataset.globeCountry = country;
          element.dataset.globeStartLatitude = String(coordinates[0]);
          element.dataset.globeStartLongitude = String(coordinates[1]);
        }
        planet = window.planetaryjs.planet();
        planet.projection.scale(144).translate([160,160]).rotate([longitude,latitude,0]);
        land = window.topojson.feature(world,world.objects.land);
        path = window.d3.geo.path().projection(planet.projection).context(context);
        ready = true; readColours(); element.dataset.globeReady = 'true'; sync();
      } catch (error) {
        element.dataset.globeError = 'true';
        context.clearRect(0,0,320,320); context.strokeStyle = colours.accent;
        context.lineWidth = 2; context.beginPath(); context.arc(160,160,144,0,Math.PI*2); context.stroke();
      }
    }
    readColours();
    const intersection = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      if (visible) initialize(); sync();
    }, {rootMargin:'100px'});
    intersection.observe(element);
    const appearance = new MutationObserver(readColours);
    appearance.observe(document.documentElement,{attributes:true,attributeFilter:['data-luma-colour']});
    motion.addEventListener('change',sync); document.addEventListener('visibilitychange',sync);
    instances.set(element, () => {
      destroyed = true; cancelAnimationFrame(frame); intersection.disconnect(); appearance.disconnect();
      motion.removeEventListener('change',sync); document.removeEventListener('visibilitychange',sync); instances.delete(element);
    });
  }
  const scan = () => document.querySelectorAll('[data-reseller-globe]').forEach(attach);
  window.LumaResellerGlobes = {scan};
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',event => {
    instances.forEach((destroy,element) => { if (event.target.contains(element)) destroy(); });
  });
  scan();
})();
